
    var riot = require('riot')
    
riot.tag2('checkout', '<signin-modal onsignin="{signin}" reload="{opts.reload}"></signin-modal> <div class="btn-group btn-group-justified"> <div onclick="{goto.bind(null,1)}" riot-tag="i18n" class="btn btn-default {\'btn-primary\':step==1}">Basket</div> <div riot-tag="i18n" class="btn btn-default {\'disabled\':step&lt;2,\'btn-primary\':step==2}">Choose Address</div> <div riot-tag="i18n" class="btn btn-default {\'disabled\':step&lt;3,\'btn-primary\':step==3}">Confirm Details</div> <div riot-tag="i18n" class="btn btn-default {\'disabled\':step&lt;4,\'btn-primary\':step==4}">Enter Payment Details</div> <div riot-tag="i18n" class="btn btn-default {\'disabled\':step&lt;5,\'btn-primary\':step==5}">Order Confirmation</div> </div><br> <basket editable="{editable}" riot-src="{opts.basketsrc}" language="{opts.language}" currency="{opts.currency}" showvat="{opts.showvat}"></basket> <hr> <div if="{step==1}"> <div if="{basketHasItems}" class="row"> <div class="col-xs-12"> <p riot-tag="i18n">Please choose from the options below</p> <div if="{!signedin}" onclick="{showsignin}" riot-tag="i18n" class="btn btn-default">Sign In</div> <div if="{!opts.forcelogin}" onclick="{goto.bind(null,2)}" riot-tag="i18n" __disabled="{basket.errors}" class="btn btn-primary">Continue to Guest Checkout</div><a if="{opts.forcelogin}" riot-tag="i18n" href="/system/sign_up/" class="btn btn-primary">Sign Up</a> </div> </div><br> </div> <div if="{step==2}"> <form onsubmit="{proceed}" class="form-horizontal"> <div class="row"> <div class="col-sm-6"> <h3 riot-tag="i18n">Billing Details</h3><br> <forminput name="billing.first_name" value="{transaction.billing.first_name}" onupdate="{handleUpdate}" label="First Name" isrequired></forminput> <forminput name="billing.surname" value="{transaction.billing.surname}" onupdate="{handleUpdate}" label="Surname" isrequired></forminput> <forminput show="{opts.showorg}" name="billing.org_name" value="{transaction.billing.org_name}" onupdate="{handleUpdate}" label="Organisation Name"></forminput> <address-search key="{opts.addressSearchKey}" on-address-selected="{handleAddressSelected.bind(null, \'billing\')}" on-error="{handleAddressSearchError.bind(null, \'billing\')}" if="{opts.addressSearchKey}"></address-search> <div if="{billingAddressSearchError}" class="form-group has-error"> <div class="col-sm-8 col-sm-offset-4"> <p riot-tag="i18n" class="help-block">Address Search isn&#39;t working right now, please complete address below or try again.</p> </div> </div> <formtextarea name="billing.address" value="{transaction.billing.address}" onupdate="{handleUpdate}" label="Address" isrequired if="{billingAddressShow}"></formtextarea> <forminput name="billing.city" value="{transaction.billing.city}" onupdate="{handleUpdate}" label="City" isrequired if="{billingAddressShow}"></forminput> <formselect default="Select State" name="billing.state" value="{transaction.billing.state}" onupdate="{handleUpdate}" label="State" isrequired="{transaction.billing.country==\'US\'}" options="{stateCodes}" if="{billingAddressShow &amp;&amp; transaction.billing.country==\'US\'}"></formselect> <forminput name="billing.postcode" value="{transaction.billing.postcode}" onupdate="{handleUpdate}" label="Postcode" isrequired maxlength="20" if="{billingAddressShow}"></forminput> <formselect name="billing.country" value="{transaction.billing.country}" onupdate="{handleUpdate}" label="Country" options="{countryCodes}" isrequired default="Select Country"></formselect> <forminput name="billing.email" value="{transaction.billing.email}" onupdate="{handleUpdate}" label="Email" isrequired type="{\'email\'}"></forminput> <forminput name="billing.telephone" value="{transaction.billing.telephone}" onupdate="{handleUpdate}" label="Telephone" isrequired></forminput> <forminput show="{opts.ponumber}" name="po_number" value="{transaction.po_number}" onupdate="{handleUpdate}" label="Your Purchase Order No."></forminput> <forminput show="{opts.clientvat}" name="client_vat" value="{transaction.client_vat}" onupdate="{handleUpdate}" label="Your VAT No."></forminput> </div> <div class="col-sm-6"> <h3 riot-tag="i18n">Delivery Details</h3><br> <formcheckbox name="sameasbilling" value="{sameasbilling}" onupdate="{toggleDelivery}" label="Same as billing"></formcheckbox> <forminput name="delivery.first_name" value="{transaction.delivery.first_name}" onupdate="{handleUpdate}" __disabled="{sameasbilling}" label="First Name" isrequired="{!sameasbilling}"></forminput> <forminput name="delivery.surname" value="{transaction.delivery.surname}" onupdate="{handleUpdate}" __disabled="{sameasbilling}" label="Surname" isrequired="{!sameasbilling}"></forminput> <forminput if="{opts.showorg}" name="delivery.org_name" value="{transaction.delivery.org_name}" onupdate="{handleUpdate}" label="Organisation Name" __disabled="{sameasbilling}" isrequired="{!sameasbilling}"></forminput> <address-search key="{opts.addressSearchKey}" on-address-selected="{handleAddressSelected.bind(null, \'delivery\')}" on-error="{handleAddressSearchError.bind(null, \'delivery\')}" if="{opts.addressSearchKey}"></address-search> <div if="{deliveryAddressSearchError}" class="form-group has-error"> <div class="col-sm-8 col-sm-offset-4"> <p riot-tag="i18n" class="help-block">Address Search isn&#39;t working right now, please complete address below or try again.</p> </div> </div> <formtextarea name="delivery.address" value="{transaction.delivery.address}" onupdate="{handleUpdate}" __disabled="{sameasbilling}" label="Address" isrequired="{!sameasbilling}" if="{deliveryAddressShow}"></formtextarea> <forminput name="delivery.city" value="{transaction.delivery.city}" onupdate="{handleUpdate}" __disabled="{sameasbilling}" label="City" isrequired="{!sameasbilling}" if="{deliveryAddressShow}"></forminput> <formselect default="Select State" name="delivery.state" value="{transaction.delivery.state}" onupdate="{handleUpdate}" __disabled="{sameasbilling}" label="State" options="{stateCodes}" isrequired="{!sameasbilling &amp;&amp; transaction.delivery.country==\'US\'}" if="{deliveryAddressShow &amp;&amp; transaction.delivery.country==\'US\'}"></formselect> <forminput name="delivery.postcode" value="{transaction.delivery.postcode}" onupdate="{handleUpdate}" __disabled="{sameasbilling}" label="Postcode" maxlength="20" isrequired="{!sameasbilling}" if="{deliveryAddressShow}"></forminput> <formselect name="delivery.country" value="{transaction.delivery.country}" onupdate="{handleUpdate}" __disabled="{sameasbilling}" label="Country" options="{countryCodes}" isrequired="{!sameasbilling}" default="Select Country"></formselect> </div> </div> <div class="row"> <div class="col-xs-12"> <div onclick="{goto.bind(null,1)}" riot-tag="i18n" class="btn btn-default">Go Back</div> <div if="{!signedin}" onclick="{showsignin}" riot-tag="i18n" class="btn btn-default">Sign In</div> <button type="submit" riot-tag="i18n" __disabled="{basket.errors}" class="btn btn-primary">Proceed</button> </div> </div> </form><br> </div> <div if="{step==3}"> <form onsubmit="{confirm}" class="form-horizontal"> <div class="row"> <div class="col-sm-6"> <h3 riot-tag="i18n">Billing Details</h3><br> <formstatic name="billing.first_name" value="{transaction.billing.first_name}" label="First Name"></formstatic> <formstatic name="billing.surname" value="{transaction.billing.surname}" label="Surname"></formstatic> <formstatic show="{opts.showorg}" name="billing.org_name" value="{transaction.billing.org_name}" label="Organisation Name"></formstatic> <formstatictextarea name="billing.address" value="{transaction.billing.address}" label="Address"></formstatictextarea> <formstatic name="billing.city" value="{transaction.billing.city}" label="City"></formstatic> <formstatic name="billing.state" value="{findStateFromCode(transaction.billing.state)}" label="State" if="{transaction.billing.state}"></formstatic> <formstatic name="billing.postcode" value="{transaction.billing.postcode}" label="Postcode"></formstatic> <formstatic name="billing.country" value="{findCountryFromCode(transaction.billing.country)}" label="Country"></formstatic> <formstatic name="billing.email" value="{transaction.billing.email}" label="Email"></formstatic> <formstatic name="billing.telephone" value="{transaction.billing.telephone}" label="Telephone"></formstatic> <formstatic show="{opts.ponumber &amp;&amp; transaction.po_number}" name="po_number" value="{transaction.po_number}" label="Your Purchase Order No."></formstatic> <formstatic show="{opts.clientvat &amp;&amp; transaction.client_vat}" name="po_number" value="{transaction.client_vat}" label="Your VAT No."></formstatic><br> <offer if="{opts.showoffers}" offer-accepted="{handleOfferAccepted}"></offer> </div> <div class="col-sm-6"> <h3 riot-tag="i18n">Delivery Details</h3><br> <formstatic name="delivery.first_name" value="{transaction.delivery.first_name}" label="First Name"></formstatic> <formstatic name="delivery.surname" value="{transaction.delivery.surname}" label="Surname"></formstatic> <formstatic show="{opts.showorg}" name="delivery.org_name" value="{transaction.delivery.org_name}" label="Organisation Name"></formstatic> <formstatictextarea name="delivery.address" value="{transaction.delivery.address}" label="Address"></formstatictextarea> <formstatic name="delivery.city" value="{transaction.delivery.city}" label="City"></formstatic> <formstatic name="delivery.state" value="{findStateFromCode(transaction.delivery.state)}" label="State" if="{transaction.delivery.state}"></formstatic> <formstatic name="delivery.postcode" value="{transaction.delivery.postcode}" label="Postcode"></formstatic> <formstatic name="delivery.country" value="{findCountryFromCode(transaction.delivery.country)}" label="Country"></formstatic> <div show="{totalweight &gt; 0}"> <formselect name="postage" value="{transaction.postage}" onupdate="{selectPostage}" label="Postage" options="{postageOptions}" if="{postageOptions.length &gt; 0}" default="Select Postage" isrequired></formselect> <div class="row"> <div class="col-md-8 col-md-offset-4"> <div if="{postageById[transaction.postage] &amp;&amp; postageById[transaction.postage].description}" class="alert alert-info"> <p riot-tag="i18n">{parent.postageById[parent.transaction.postage].description}</p> </div> </div> </div> </div> </div> </div> <div class="row"> <div class="col-xs-12"> <div onclick="{goto.bind(null,2)}" riot-tag="i18n" class="btn btn-default">Go Back</div> <button type="submit" if="{showConfirm &amp;&amp; basket.total &gt; 0}" __disabled="{basket.errors || confirming || invoicing}" riot-tag="i18n" class="btn btn-primary">Pay By Card<span if="{confirming}" class="fa fa-refresh fa-spin"></span></button> <button onclick="{invoice}" if="{showConfirm &amp;&amp; opts.invoice &amp;&amp; basket.items &amp;&amp; basket.items.length &gt; 0}" __disabled="{basket.errors || confirming || invoicing}" class="btn btn-primary">{basket.total > 0 ? \'Invoice Me \' : \'Confirm Order \'} <span if="{invoicing}" class="fa fa-refresh fa-spin"></span></button> </div> </div> </form><br> </div> <div if="{step==4}"> <div if="{transactionError}" class="row"> <div class="col-xs-12"> <div class="alert alert-warning"> <p riot-tag="i18n">{parent.transactionErrorMessage || ⁗There has been a problem with your transaction please go back and try again.⁗} <div onclick="{tryagain}" class="btn btn-warning">Try Again</div> </p> </div> </div> </div> </div> <div if="{step==5}"> <div if="{transactionMessage}" class="row"> <div class="col-xs-12"> <div class="alert alert-success"> <p>{transactionMessage}</p> </div> </div> <div class="col-xs-12"><a href="/" class="btn btn-default">Return To Homepage</a></div> </div> </div> <paymentform transaction="{paymentTransaction}" if="{paymentTransaction}"></paymentform>', '@media (max-width: 991px) { checkout .btn-group-justified .btn { display: block; width: auto; } }', '', function(opts) {
var concatAddressLines, countryApi, loginApi, postageApi, resource, statesApi, transactionApi;

resource = require('riot-kit/utils/apiResource.coffee');

loginApi = new resource(opts.loginsrc || '/duocms/api/login', true);

transactionApi = new resource(opts.transactionsrc || '/duocms/api/transactions', true);

postageApi = new resource(opts.postagesrc || '/duocms/api/postage', true);

countryApi = new resource(opts.countrysrc || '/duocms/api/countries', true);

statesApi = new resource(opts.statesrc || '/duocms/api/states', true);

this.step = 1;

this.editable = true;

this.signedin = false;

this.sameasbilling = window.localStorage.getItem("address_sameasbilling") || false;

this.billingAddressShow = false;

this.deliveryAddressShow = false;

this.countryCodes = [];

this.debounceUpdate = null;

this.stripeLoaded = false;

this.on('mount', function() {
  loginApi.get((function(_this) {
    return function(user, err) {
      if (err == null) {
        return _this.signin(user);
      }
    };
  })(this));
  return countryApi.get((function(_this) {
    return function(countries) {
      _this.countryCodes = countries.map(function(country) {
        return {
          label: country.name,
          value: country.code
        };
      });
      return statesApi.get(function(states) {
        _this.stateCodes = states.map(function(state) {
          return {
            label: state.name,
            value: state.code
          };
        });
        _this.billingAddressShow = _this.opts.addressSearchKey == null;
        _this.deliveryAddressShow = _this.opts.addressSearchKey == null;
        _this.tags.basket.on('update', function() {
          var ref;
          _this.basketHasItems = _this.tags.basket.hasItems();
          return _this.basket = (ref = _this.tags.basket) != null ? ref.basket : void 0;
        });
        return _this.update();
      });
    };
  })(this));
});

this.on('update', (function(_this) {
  return function() {
    var ref;
    if (!_this.transaction.billing.state) {
      _this.transaction.billing.state = window.localStorage.getItem("address_state");
    }
    if (!_this.transaction.billing.country) {
      _this.transaction.billing.country = window.localStorage.getItem("address_country");
    } else {
      _this.transaction.billing.country = _this.transaction.billing.country.toUpperCase();
    }
    if (_this.transaction.billing.country !== 'US') {
      _this.transaction.billing.state = "";
    }
    if (_this.sameasbilling && (_this.transaction.billing != null)) {
      _this.transaction.delivery.org_name = _this.transaction.billing.org_name;
      _this.transaction.delivery.first_name = _this.transaction.billing.first_name;
      _this.transaction.delivery.surname = _this.transaction.billing.surname;
      _this.transaction.delivery.address = _this.transaction.billing.address;
      _this.transaction.delivery.city = _this.transaction.billing.city;
      _this.transaction.delivery.state = _this.transaction.billing.state;
      _this.transaction.delivery.postcode = _this.transaction.billing.postcode;
      _this.transaction.delivery.country = _this.transaction.billing.country;
    }
    _this.showConfirm = _this.transaction.postage;
    return _this.totalweight = (ref = _this.basket) != null ? ref.items.reduce((function(a, product) {
      return a + (product.weight || 0);
    }), 0) : void 0;
  };
})(this));

this.transaction = {
  billing: {
    first_name: "",
    surname: "",
    email: "",
    address: "",
    postcode: "",
    telephone: "",
    state: window.localStorage.getItem("address_state") || "",
    country: window.localStorage.getItem("address_country") || ""
  },
  delivery: {
    first_name: "",
    surname: "",
    email: "",
    address: "",
    postcode: "",
    telephone: "",
    country: ""
  },
  postage: ''
};

this.toggleDelivery = (function(_this) {
  return function(ev) {
    _this.sameasbilling = ev.value;
    window.localStorage.setItem("address_sameasbilling", _this.sameasbilling);
    if (_this.sameasbilling) {
      _this.deliveryAddressShow = true;
    }
    _this.update();
    return _this.update();
  };
})(this);

this.goto = (function(_this) {
  return function(step) {
    switch (step) {
      case 2:
        _this.editable = false;
        _this.tags.basket.trigger('updateBasket');
        break;
      case 3:
        _this.tags.basket.trigger('comfirmBasket', _this.transaction.postage, _this.transaction.delivery.country);
        postageApi.get({
          language: opts.language
        }, function(options) {
          var ref;
          _this.postageById = {};
          _this.postageOptions = options.map(function(opt) {
            _this.postageById[opt.id] = opt;
            return {
              label: opt.name,
              value: opt.id
            };
          });
          _this.selectPostage({
            value: (ref = _this.postageOptions[0]) != null ? ref.value : void 0
          });
          return _this.update();
        });
        _this.transaction.postage = null;
        _this.editable = false;
        break;
      case 4:
        _this.editable = false;
        break;
      case 5:
        _this.editable = false;
        break;
      default:
        _this.editable = true;
    }
    _this.step = step;
    return _this.update();
  };
})(this);

this.handleOfferAccepted = (function(_this) {
  return function() {
    if (_this.transaction.postage != null) {
      return _this.tags.basket.trigger('comfirmBasket', _this.transaction.postage, _this.transaction.delivery.country);
    } else {
      return _this.tags.basket.trigger('updateBasket');
    }
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(row) {
    var ref, ref1;
    if (row != null) {
      if ((ref = row.name) != null) {
        if ((ref1 = ref.split(".")) != null) {
          ref1.reduce(function(prev, curr, idx, arr) {
            if (idx === arr.length - 1) {
              prev[curr] = row.value;
            }
            if (curr === "country") {
              window.localStorage.setItem("address_country", row.value);
              if (row.value !== "US") {
                window.localStorage.removeItem("address_state");
              }
            }
            if (curr === "state") {
              window.localStorage.setItem("address_state", row.value);
            }
            return prev[curr];
          }, _this.transaction);
        }
      }
    }
    if (_this.debounceUpdate) {
      clearTimeout(_this.debounceUpdate);
    }
    return _this.debounceUpdate = setTimeout(function() {
      return _this.update();
    }, 200);
  };
})(this);

this.handleAddressSelected = (function(_this) {
  return function(addressType, address) {
    _this.transaction[addressType].address = concatAddressLines([address.line_1, address.line_2, address.line_3, address.post_town]);
    _this.transaction[addressType].postcode = address.postcode;
    _this[addressType + 'AddressShow'] = true;
    return _this.update();
  };
})(this);

this.handleAddressSearchError = (function(_this) {
  return function(addressType, err) {
    _this[addressType + 'AddressSearchError'] = true;
    _this[addressType + 'AddressShow'] = true;
    return _this.update();
  };
})(this);

concatAddressLines = function(lines) {
  return lines.reduce(function(prev, line) {
    if (line === "") {
      return prev;
    }
    return prev += line + '\n';
  }, "");
};

this.proceed = (function(_this) {
  return function(e) {
    return _this.goto(3);
  };
})(this);

this.selectPostage = (function(_this) {
  return function(e) {
    _this.transaction.postage = e.value;
    _this.update();
    return setTimeout(function() {
      _this.tags.basket.trigger('comfirmBasket', _this.transaction.postage, _this.transaction.delivery.country);
      return _this.update();
    });
  };
})(this);

this.confirm = (function(_this) {
  return function() {
    _this.confirming = true;
    _this.update();
    return transactionApi.save(_this.transaction, function(transaction, err) {
      var script;
      if (err != null) {
        _this.transactionError = err;
        if (err.message) {
          _this.transactionErrorMessage = err.message;
        }
      } else if (transaction.session) {
        if (_this.stripeLoaded) {
          _this.stripeProcess(transaction);
        }
        script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.onload = function() {
          _this.stripeLoaded = true;
          return _this.stripeProcess(transaction);
        };
        script.src = 'https://js.stripe.com/v3/';
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        _this.paymentTransaction = transaction;
      }
      _this.update();
      return _this.goto(4);
    });
  };
})(this);

this.stripeProcess = (function(_this) {
  return function(transaction) {
    var stripe;
    stripe = Stripe(transaction.pubkey);
    return stripe.redirectToCheckout({
      sessionId: transaction.session.id
    }).then(function(result) {
      _this.transactionErrorMessage = result.error.message;
      return _this.update();
    });
  };
})(this);

this.invoice = (function(_this) {
  return function() {
    _this.transaction.invoice = true;
    _this.invoicing = true;
    _this.update();
    return transactionApi.save(_this.transaction, function(transaction, err) {
      if (err != null) {
        _this.transactionError = err;
        _this.update();
        return _this.goto(4);
      } else {
        if ((transaction != null ? transaction.id : void 0) != null) {
          window.location.href = "/duocms/api/transactions/success/" + transaction.id;
        } else {
          _this.transactionMessage = transaction;
        }
        _this.update();
        return _this.goto(5);
      }
    });
  };
})(this);

this.showsignin = (function(_this) {
  return function() {
    return _this.tags['signin-modal'].trigger('show');
  };
})(this);

this.findCountryFromCode = (function(_this) {
  return function(code) {
    var countries, country, ref;
    countries = (function() {
      var i, len, ref, results;
      ref = this.countryCodes;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        country = ref[i];
        if (country.value === code) {
          results.push(country);
        }
      }
      return results;
    }).call(_this);
    return (countries != null ? (ref = countries[0]) != null ? ref.label : void 0 : void 0) || '';
  };
})(this);

this.findStateFromCode = (function(_this) {
  return function(code) {
    var ref, state, states;
    states = (function() {
      var i, len, ref, results;
      ref = this.stateCodes;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        state = ref[i];
        if (state.value === code) {
          results.push(state);
        }
      }
      return results;
    }).call(_this);
    return (states != null ? (ref = states[0]) != null ? ref.label : void 0 : void 0) || '';
  };
})(this);

this.signin = (function(_this) {
  return function(user) {
    var ref, ref1;
    _this.signedin = true;
    _this.transaction.billing.first_name = user != null ? user.first_name : void 0;
    _this.transaction.billing.surname = user != null ? user.surname : void 0;
    _this.transaction.billing.email = user != null ? user.email : void 0;
    _this.transaction.billing.address = user != null ? user.address : void 0;
    _this.transaction.billing.city = user != null ? user.city : void 0;
    _this.transaction.billing.state = user != null ? user.state : void 0;
    _this.transaction.billing.postcode = user != null ? user.postcode : void 0;
    _this.transaction.billing.country = user != null ? user.country : void 0;
    _this.transaction.billing.telephone = user != null ? user.phone1 : void 0;
    _this.transaction.billing.org_name = user != null ? (ref = user.org) != null ? ref.name : void 0 : void 0;
    _this.billingAddressShow = true;
    if (_this.sameasbilling && (user != null)) {
      _this.transaction.delivery.first_name = user.first_name;
      _this.transaction.delivery.surname = user.surname;
      _this.transaction.delivery.address = user.address;
      _this.transaction.delivery.city = user != null ? user.city : void 0;
      _this.transaction.delivery.state = user != null ? user.state : void 0;
      _this.transaction.delivery.postcode = user.postcode;
      _this.transaction.delivery.country = user.country;
      _this.transaction.delivery.org_name = user != null ? (ref1 = user.org) != null ? ref1.name : void 0 : void 0;
    }
    return _this.goto(2);
  };
})(this);

this.tryagain = (function(_this) {
  return function() {
    _this.transactionError = null;
    _this.transactionErrorMessage = null;
    return _this.goto(2);
  };
})(this);
});
riot.tag2('paymentform', '<br> <p>You are about to be redirected to our payment provider.</p><br> <form action="{transaction.url}" method="POST" name="paymentform"> <input each="{key,val in transaction.data}" type="hidden" name="{key}" value="{val}"> </form>', '', '', function(opts) {
this.on('mount', function() {
  if (opts.transaction != null) {
    this.transaction = opts.transaction;
    this.update();
    return setTimeout((function(_this) {
      return function() {
        return _this.paymentform.submit();
      };
    })(this), 2000);
  }
});
});
    
  